export default __webpack_public_path__ + "static/media/logo.557c536b.png";